/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyCountInfo } from './EvmDailyCountInfo';

export type EvmHomeTotalValidatorInfo = {
    TVCNT: string;
    CNGP: string;
    TRXHTP: EvmHomeTotalValidatorInfo.TRXHTP;
    DVLIST: Array<EvmDailyCountInfo>;
};

export namespace EvmHomeTotalValidatorInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

